import { DatasetType } from './domain'

// CPM (cost per 1,000 users reached) is fixed along two axes: the audience type
// and whether the segment is modeled. A modeled (lookalike-expanded) audience
// adds a 10% surcharge.
//   user attribute  $0.75   transaction  $1.50   crossed  $1.75   (+10% modeled)
const MODELED_SURCHARGE = 1.1

// The CPM rate for an audience of `datasetType`, with the modeled uplift when
// `isModeled`. Returns undefined for an unknown/half-streamed type so callers can
// omit the price rather than show a wrong one.
export function cpmFor(
    datasetType: DatasetType | undefined,
    isModeled: boolean
): number | undefined {
    const base =
        datasetType === DatasetType.USER_ATTRIBUTE
            ? 0.75
            : datasetType === DatasetType.TRANSACTION
              ? 1.5
              : datasetType === DatasetType.CROSSED
                ? 1.75
                : undefined
    if (base === undefined) return undefined
    return isModeled ? base * MODELED_SURCHARGE : base
}

// The CPM rate as a dollar amount, e.g. 1.5 -> "$1.50". The "CPM" unit label is
// added by the UI beside it.
export function formatCpm(cpm: number): string {
    return `$${cpm.toFixed(2)}`
}
